export default __webpack_public_path__ + "locales/it/PreparationPortal.json?hash=dd51b8c194675b057c6eea143b09dfde";